import { makeStyles, mergeClasses } from "@fluentui/react-components";
import * as React from "react";

export type RowProps = React.HTMLAttributes<HTMLDivElement> & {
  noGutter?: boolean;
};

const useStyles = makeStyles({
  row: {
    display: "flex",
    flexWrap: "wrap",
    marginRight: "-0.75rem",
    marginLeft: "-0.75rem",
  },

  noGutter: {
    marginLeft: "0px",
    marginRight: "0px",
  },
});

export const Row: React.FC<RowProps> = (props) => {
  const styles = useStyles();
  return (
    <div
      {...props}
      className={mergeClasses(
        styles.row,
        props.noGutter && styles.noGutter,
        props.className
      )}
    >
      {props.children}
    </div>
  );
};
